import styled from 'styled-components';
import { UIElements } from '@ansvar-sakerhet/ui';
import * as Dialog from '@radix-ui/react-dialog';

const Overlay = styled(Dialog.Overlay)`
  background-color: rgba(0, 0, 0, 0.25);
  position: fixed;
  z-index: 200;
  inset: 0;
  display: grid;
  place-items: center;
  overflow-y: auto;
`;

const Content = styled(Dialog.Content)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  margin: 48px 0;
  width: min(834px, 92vw);
  max-height: calc(100vh - 96px);
  overflow-y: auto;
  padding: 32px 40px;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.15);
`;

const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
`;

const CloseButton = styled(Dialog.Close)`
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 0;
`;

const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
`;

const OverwriteRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const RadioRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const List = styled.ul`
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const PreviewItem = styled.div`
  border: 1px solid #cbcbcb;
  border-radius: 4px;
  overflow: hidden;
`;

const PreviewToggle = styled.button`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #fbfbfb;
  border: none;
  cursor: pointer;
  text-align: left;
`;

const PreviewBody = styled.div`
  padding: 12px 16px;
  border-top: 1px solid #cbcbcb;
  background: #fff;
  font-size: 14px;
  line-height: 1.4;

  p {
    margin: 0 0 8px;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

const ContentFooter = styled.div`
  display: flex;
  gap: 16px;
  padding-top: 8px;
`;

const SkipReason = styled.span`
  color: #666;
`;

const Description = styled(UIElements.B2)`
  margin: 0 0 24px;
`;

const EmptyState = styled.p`
  margin: 0;
  color: #666;
`;

export const S = {
  ...UIElements,
  Overlay,
  Content,
  ContentHeader,
  CloseButton,
  Section,
  OverwriteRow,
  RadioRow,
  List,
  PreviewItem,
  PreviewToggle,
  PreviewBody,
  ContentFooter,
  SkipReason,
  EmptyState,
  Description,
};
